import { render, staticRenderFns } from "./urgentChangeStatis.vue?vue&type=template&id=7ed07b06&scoped=true&"
import script from "./urgentChangeStatis.vue?vue&type=script&lang=js&"
export * from "./urgentChangeStatis.vue?vue&type=script&lang=js&"
import style0 from "./urgentChangeStatis.vue?vue&type=style&index=0&id=7ed07b06&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed07b06",
  null
  
)

export default component.exports